import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-missing-page',
  templateUrl: './missing-page.component.html',
  styleUrls: ['./missing-page.component.scss']
})
export class MissingPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
